// extracted by mini-css-extract-plugin
export var animationContainer = "_go-0";
export var footer = "_go-1";
export var gray = "_go-2";
export var lineItem = "_go-3";
export var lineItemImage = "_go-4";
export var lineItemInfo = "_go-5";
export var lineItemText = "_go-6";
export var lineItems = "_go-7";
export var modalContent = "_go-8";
export var options = "_go-9";
export var orderName = "_go-a";
export var refundAmount = "_go-b";